import { useCallback, useId, useRef, useState } from 'react'
import type { ChangeEvent, PropsWithChildren, ReactNode, RefObject } from 'react'
import { css } from '~/styled-system/css'

export function ReadMore({
  children,
  openLabel,
  closeLabel,
  scrollTargetRef,
}: PropsWithChildren<{
  openLabel: ReactNode
  closeLabel: ReactNode
  scrollTargetRef?: RefObject<HTMLElement>
}>) {
  const ref = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (scrollTargetRef?.current && ref.current && !e.target.checked) {
      const { top } = ref.current.getBoundingClientRect()
      if (top < 0) {
        scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
    setOpen(e.target.checked)
  }, [])
  const id = useId()
  return (
    <div ref={ref}>
      <input id={id} type="checkbox" className="peer" onChange={onChange} hidden />
      <div
        className={css({
          display: 'grid',
          gridTemplateRows: '[0fr]',
          transition: '[grid-template-rows 0.3s ease-out]',
          _peerChecked: {
            gridTemplateRows: '[1fr]',
          },
        })}
      >
        <div className={css({ overflowY: 'hidden' })}>{children}</div>
      </div>
      <label htmlFor={id}>{open ? closeLabel : openLabel}</label>
    </div>
  )
}
